// src/pages/Workers/Tasks/ExportTasksExcel.js
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import i18n from "../../../../i18n";
const ExportTasksExcel = async (data) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Tasks");
const t = i18n.t.bind(i18n);

  worksheet.columns = [
    { header: t("projectManagement.id"), key: "id", width: 8 },
    { header: t("projectManagement.taskName"), key: "title", width: 25 },
    { header:t("projectManagement.priority"), key: "priority", width: 15 },
    { header: t("projectManagement.createdAt"), key: "createdAt", width: 22 },
    { header:t("projectManagement.deadline"), key: "deadline", width: 22 },
    { header:t("projectManagement.location"), key: "location", width: 25 },
    { header: t("projectManagement.status"), key: "status", width: 15 },
  ];

  worksheet.addRows(data);

  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "003149" } };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  saveAs(blob, `Tasks_Report_${new Date().toISOString().slice(0, 10)}.xlsx`);
};

export default ExportTasksExcel;
